import ProfileView from '../../features/perfil/layouts/profile';

// TSS vite/01 — thin page. Mounts the profile feature ("Mi cuenta").
// Guarded by <AuthRoute> (shell); the profile is role-agnostic — every
// authenticated client has one, so no permission/role gate here.

export default function PerfilPage() {
    return <ProfileView />;
}
